import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-full" }
const _hoisted_2 = { class: "whitespace-pre-wrap mb-4" }

import { useEventHandlers } from '@/composables/eventHandlers'
import { useI18n } from 'vue-i18n'


export default /*#__PURE__*/_defineComponent({
  __name: 'ServerOverloaded',
  setup(__props) {

const { t } = useI18n()
const { clickDelay } = useEventHandlers()
const refresh = async () => window.location.reload()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", _hoisted_2, _toDisplayString(_unref(t)('server_overloaded_message')), 1),
    _createElementVNode("button", {
      class: "gw-button -primary relative",
      onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_unref(clickDelay)(refresh)), ["prevent"]))
    }, [
      _createElementVNode("span", null, _toDisplayString(_unref(t)('refresh')), 1)
    ])
  ]))
}
}

})